import { render, staticRenderFns } from "./EditProfileAsConsultant.vue?vue&type=template&id=7cba741a"
import script from "./EditProfileAsConsultant.vue?vue&type=script&lang=js"
export * from "./EditProfileAsConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports